import { forwardRef } from 'react';

import { Input, InputProps } from '@components/primitives/Input';
import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

/** The group draws the box, so the control renders without chrome of its own. */
export const InputGroupInput = forwardRef<
  HTMLInputElement,
  Omit<InputProps, 'variant' | 'width'>
>(function InputGroupInput({ className, ...props }, ref) {
  return (
    <Input
      ref={ref}
      variant="plain"
      className={cn(css.control, className)}
      {...props}
    />
  );
});
